module.exports = __webpack_public_path__ + "img/mine-help.c122eca1.png";